import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NotificationMessageDataModel} from '../../models/messaging/notification-message-data.model';
import {NotificationDataModel} from '../../models/messaging/notification-data.model';
import {tap} from 'rxjs/operators';
import {NotificationDestinationDataModel} from '../../models/messaging/notification-destination-data.model';
import {NotificationConversationDataModel} from '../../models/messaging/notification-conversation-data.model';
import {SignalrService} from "../socket/signalr.service";
import {AuthenticationService} from "../../modules/auth/services/authentication.service";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  messageUpdate: Subject<void> = new Subject();
  numNotifications = 0;
  instantMessages: NotificationDestinationDataModel[] = [];

  constructor(private http: HttpClient,
              private signalrService: SignalrService,
              private authenticationService: AuthenticationService) {
    this.signalrService.messageUser.subscribe((res) => {
      switch (res.messageType) {
        /*case SignalrService.UPDATE_PAGES:
          // this.getPages();
          const dest = JSON.parse(res.message as unknown as string) as NotificationDestinationDataModel;
          if (dest && dest.UserID.toLowerCase() === this.authenticationService.currentUserValue.authdata.userid.toLowerCase()) {
            // this.playSound(dest.UserID);
          }
          break;
        case SignalrService.PAGE_SEEN:
          const dest1 = JSON.parse(res.message as unknown as string) as NotificationDestinationDataModel;
          const idx = this.pages.findIndex(p => p.dataNotification.NotificationID === dest1.NotificationID);
          if (idx > -1) {
            // this.pages.splice(idx, 1);
            // this.numNewNotifications--;
          }
          break;*/
        case SignalrService.PAGE_SEEN:
        case SignalrService.UPDATE_CHAT_MESSAGE:
          this.getMessagesForUser(this.authenticationService.currentUserValue.authdata.userid).subscribe((notifications) => {
            this.messageUpdate.next();
          });
          /*this.chatService.getNumUnreadMessages(this.localStorageService.currentUserData.authdata.userid).subscribe((numRead) => {
            //
          });*/
          break;
      }
    });
  }

  getPredefinedMessages() {
    return this.http.get<NotificationMessageDataModel[]>('api/messaging/get-predefined-messages');
  }

  savePredefinedMessages(messages: NotificationMessageDataModel[]) {
    return this.http.post<NotificationMessageDataModel[]>('api/messaging/save-predefined-messages', messages);
  }

  sendMessage(message: NotificationDataModel) {
    return this.http.post<void>('api/messaging/send-message', message);
  }

  sendToDestination(fromId: string, destinations: NotificationDestinationDataModel[]) {
    return this.http.post<NotificationDestinationDataModel>(`api/messaging/send-to-destination/${fromId}`, {destinations});
  }

  getConversations(fromId: string, toId: string) {
    return this.http.get<NotificationConversationDataModel[]>(`api/messaging/get-conversations/${fromId}/${toId}`);
  }

  getDestinations(conversationId: string) {
    return this.http.get<NotificationDestinationDataModel[]>(`api/messaging/get-destinations/${conversationId}`);
  }

  getNumNotificationsForUser(userId: string) {
    return this.http.get<number>(`api/messaging/get-num-notifications/${userId}`).
      pipe(
        tap(_ => {
          this.numNotifications = _;
        })
    );
  }

  getMessagesForUser(userId: string) {
    return this.http.get<NotificationDestinationDataModel[]>(`api/messaging/get-messages-for-user/${userId}`)
      .pipe(
        tap((_) => {
          this.instantMessages = _;
          if (!this.instantMessages) {
            this.instantMessages = [];
          }
        })
      );
  }

  markNotificationAsSeen(notification: NotificationDataModel) {
    return this.http.post<NotificationDataModel>('api/messaging/mark-notification-seen', notification);
  }

  /*getNotificationsForUser(userid: string) {
    return this.http.get<NotificationDataModel[]>(`api/messaging/get-messages-for-user/${userId}`);
  }*/
  getPages() {
    return this.http.get<NotificationDestinationDataModel[]>(`api/messaging/get-pages`);
  }
}
